import { types as apiActionTypes } from '../../actions/api'
import takeEveryApiRequest from '../../helpers/takeEveryApiRequest'

import getStoreRetailer from './resources/stores/getStoreRetailer'
import getRetailerAssets from './resources/retailers/getRetailerAssets'
import getRetailerSlug from './resources/retailers/getRetailerSlug'
import getFlyerGibsPage from './resources/products/getFlyerGibsPage'
import getFlyerGib from './resources/products/getFlyerGib'

const {
  GET_STORE_RETAILER, GET_RETAILER_ASSETS, GET_RETAILER_SLUG,
  GET_FLYER_GIBS_PAGE, GET_FLYER_GIB,
} = apiActionTypes

function* watchApi() {
  yield takeEveryApiRequest(GET_STORE_RETAILER, getStoreRetailer)
  yield takeEveryApiRequest(GET_RETAILER_ASSETS, getRetailerAssets)
  yield takeEveryApiRequest(GET_RETAILER_SLUG, getRetailerSlug)
  yield takeEveryApiRequest(GET_FLYER_GIBS_PAGE, getFlyerGibsPage)
  yield takeEveryApiRequest(GET_FLYER_GIB, getFlyerGib)
}

export default watchApi
